var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2700_5173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1.83331C7.45251 1.83331 4.58334 4.70248 4.58334 8.24998C4.58334 13.0625 11 20.1666 11 20.1666C11 20.1666 17.4167 13.0625 17.4167 8.24998C17.4167 4.70248 14.5475 1.83331 11 1.83331ZM11 10.5416C9.73501 10.5416 8.70834 9.51498 8.70834 8.24998C8.70834 6.98498 9.73501 5.95831 11 5.95831C12.265 5.95831 13.2917 6.98498 13.2917 8.24998C13.2917 9.51498 12.265 10.5416 11 10.5416Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2700_5173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.805ecf351d6396be65ab4bf573e6a9d5.svg";
export { ForwardRef as ReactComponent };